import { RouteConfig } from 'vue-router'

const Index = () => import('./maritime-trade/Index.vue')
const LotteryRewardsPage = () => import('./maritime-trade/LotteryRewardsPage.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/maritime-trade-2025',
  name: 'activity_maritime_trade_2025',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '小商队，大航海',
    ignoreLogin: true,
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/maritime-trade-2025/lottery-rewards',
  name: 'activity_maritime_trade_2025_lottery_rewards',
  component: LotteryRewardsPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export default [indexRoute, lotteryRewardsRoute]
